import {BaseService} from './BaseService';
import {UriBuilder} from './UriBuilder';

export class ConcardisService extends BaseService {
  private readonly inventoryRoot: string;

  constructor(apiUrl: string = '') {
    super();
    this.inventoryRoot = apiUrl;
    this.apiBaseUrl = `${this.inventoryRoot}/v1/order/payment`;
  }
  async paymentProducts(): Promise<Array<string>> {
    const result = await this.restClient.GET(
      new UriBuilder()
        .fromPath(this.apiBaseUrl)
        .path('payment-products')
        .build(),
    );
    if (result.response) {
      return result.response.products as Array<string>;
    }
    return this.throwAPIError(result.error);
  }
}
